<template>
  <div v-if="images" class="container my-4">
    <b-row>
      <b-col cols="12" xl="9" >
        <form @submit.prevent="addImage">
          <b-table-simple class="table  table-bordered rounded shadow-sm overflow-hidden">
            <b-thead class="thead-light">
              <b-tr>
                <b-th class="fixed_width">Image</b-th>
                <b-th class="fixed_width"></b-th>
                <b-th>Link</b-th>
                <b-th class="text-center fixed_width">Actions</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(image, index) in images" :key="index">
                <b-td class="align-middle fixed_width p-1">
                  <img
                    :src="image.src"
                    alt="Image preview"
                    class="img-thumbnail"
                    style="width: 150px; height: auto; object-fit: contain;"
                  />
                </b-td>
                <b-td colspan="2" class="align-middle px-2">
                  <p class="mb-0 form-control" style="word-break: break-word;">{{ image.link }}</p>
                </b-td>
                <b-td class="text-center align-middle action_width">
                  <b-button
                    @click="deleteImage(index)"
                    v-b-modal.modal-delete
                    variant="danger"
                    size="sm"
                  >
                    <i class="ri-delete-bin-line"></i>
                  </b-button>
                </b-td>
              </b-tr>
    
              <b-tr v-if="images.length <= 4">
                <b-td>
                  <FileUpload class="fixed_width" :field="{ placeholder: 'DROP IMAGE' }" v-model="uploadedImages" :multiple="false" @updated="updateImages" />
                </b-td>
                <b-td class="text-center align-middle action_width">
                  <div class="my-1">
                                <b-form-radio-group
                                  v-model="inputMode"
                                  name="inputModeRadios"
                                  stacked class=" d-flex flex-row justify-content-around"
                                >
                                  <b-form-radio value="url">Link</b-form-radio>
                                  <b-form-radio value="search">Shaleh</b-form-radio>
                                </b-form-radio-group>
                              </div>
                </b-td>
                <b-td class="align-middle">
                  <div v-if="inputMode === 'search'">
                    <SearchItemsForm
                      :business-id="businessId"
                      ref="SearchItemsForm"
                      :branch-id="branchId"
                      label="Search chalet"
                      @setItem="(itemDetails) => {
                        selectedItem = `items/${itemDetails ? itemDetails.id : ''}`;
                      }"
                    />
                  </div>
    
                  <div v-if="inputMode === 'url'" class="m-2">
                    <b-form-input
                      v-model="externalLink"
                      type="text"
                      class="form-control"
                      placeholder="Enter URL"
                    />
                  </div>
                </b-td>
    
                <b-td colspan="2" class="text-center align-middle">
                  <b-button
                    type="submit"
                    variant="success"
                    class="mt-3"
                    :disabled="uploadedImages.length === 0"
                  >
                  <i class="fa fa-plus"></i> Add
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </form>
        </b-col>
        </b-row>
  </div>
</template>


<script>
import FileUpload from '@/components/FileUpload.vue';
import SearchItemsForm from '../../Reservations/SearchItemsForm.vue';

export default {
  name:"SiderAds",
  components:{FileUpload, SearchItemsForm},
  props: ['imagesData', 'businessId','branchId'],
  data() {
    return {
      inputMode: 'search', 
      uploadedImages: [],
      externalLink: "",
      images: [],
      imageModel: {
        src: '',
        link: ''
      },
      emptyImage: "",
      selectedItem: null,
    
    };
  },
  mounted() {
    this.images = this.imagesData || [];
    this.emptyImage = JSON.stringify(this.imageModel);
  },
  methods: {
    updateImages() {
      this.uploadedImages.forEach((file, index) => {
        let newImage = JSON.parse(this.emptyImage);
        newImage.src = file.src;
      });
    },
    addImage() {
      this.uploadedImages.forEach((file) => {
        let newImage = JSON.parse(this.emptyImage);
        newImage.src = file.src;
        newImage.link = this.externalLink || this.selectedItem || '#';
        this.images.push(newImage);
      });
      this.uploadedImages = []; 
      this.externalLink = ""; 
      this.selectedItem = ""; 
      this.$refs.SearchItemsForm && this.$refs.SearchItemsForm.resetSearch();
    },
    deleteImage(index) {
      this.images.splice(index, 1);
    }
  },
  watch: {
    inputMode(newVal) {
      if (newVal === 'url') {
        this.selectedItem = null;
      } else if (newVal === 'search') {
        this.externalLink = "";
      }
    },
    imagesData: {
      deep: true,
      handler(value) {
        this.images = value || [];
      }
    },
    images: {
      deep: true,
      handler(value) {
        this.$emit('updateImages', value);
      }
    }
  }
};
</script>

<style scoped>
tbody tr td{
  padding: 0;
}
.action_width {
  width: 96px;
}
.action_wrapper {
  width: 120px;
}
.fixed_width {
  width: 180px;
}
</style>